import { render, staticRenderFns } from "./userTag.vue?vue&type=template&id=0b319240&scoped=true&"
import script from "./userTag.vue?vue&type=script&lang=js&"
export * from "./userTag.vue?vue&type=script&lang=js&"
import style0 from "./userTag.vue?vue&type=style&index=0&id=0b319240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b319240",
  null
  
)

export default component.exports